import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudReminders = () => import('./staff/crudReminders')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) -> nombre
// de ruta. Fuente única para no duplicar el nombre de la ruta acá abajo y en
// el buscador (Ctrl+K, ver router/viewsRegistry.js) — evita que se
// desincronicen.
const VIEWS = {
  dashboard: 'RemindersStaffDashboard',
  crudReminders: 'RemindersStaffCrud',
}

const router =
  [
    {
      path: '/st/reminders',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recordatorios',
          }
        },
        {
          path: 'list/:reminderId?',
          name: VIEWS.crudReminders,
          component: ViewStaffCrudReminders,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recordatorios Programados',
          }
        },
      ]
    },

    {
      path: '/cu/reminders',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/reminders',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
